// https://vuex.vuejs.org/en/state.html

export default {
  message: null,
  data: null,
  name: null,
  type: null, // info, warning, error, success
};
